export class ValidationHelpers {
    public static isValidNumber(num: any): boolean {
        return (
            typeof num === 'number' &&
            !isNaN(num) &&
            isFinite(num) &&
            Math.abs(num) > 1e-5 && // 1e-5 = 0.00001
            num > Number.MIN_VALUE &&
            num < Number.MAX_VALUE
        );
    }
}